/** Utilidades de filtrado client-side compartidas por las páginas de
 *  inventario (bodega, insumos, proveedores). Las listas vienen completas
 *  del backend, así que el filtrado vive en el cliente. */

/** Minúsculas + sin acentos, para búsquedas tolerantes (Muñoz ↔ munoz). */
export function normalizarTexto(s: string): string {
  return s
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase();
}

/** True si el término aparece en alguno de los campos (normalizados).
 *  Término vacío ⇒ true (no filtra). */
export function coincideBusqueda(
  term: string,
  ...campos: (string | null | undefined)[]
): boolean {
  const t = normalizarTexto(term.trim());
  if (!t) return true;
  const heno = normalizarTexto(campos.filter(Boolean).join(" "));
  return heno.includes(t);
}

/** Filtro de estado activo/inactivo reusable. */
export type FiltroEstado = "activos" | "inactivos" | "todos";

export function pasaEstado(activo: boolean, filtro: FiltroEstado): boolean {
  if (filtro === "activos") return activo;
  if (filtro === "inactivos") return !activo;
  return true;
}
